import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import { NavLink, useSearchParams } from "react-router-dom";
import { titleToUrl } from "../../shared/extra";
import { useEffect, useState } from "react";

const Sidebar = ({ blogData }) => {
  const [categories, setCategories] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const recentPosts = blogData?.slice(0, 8)?.sort((a, b) => b?.id - a?.id);

  const categoryFiltered = (categoryItem) => {
    const selectedCategory = categoryItem.toLowerCase();
    setSearchParams({ category: selectedCategory });
  };

  useEffect(() => {
    if (blogData) {
      const categoriesData = blogData?.map(item => item?.categroies);
      const categories = new Set(categoriesData);
      setCategories([...categories]);
    }
  }, [blogData]);

  return (
    <Box sx={{
      p: 2,
      border: 1.5,
      borderColor: "lightSecondary.main",
      borderRadius: 2,
      maxWidth: {
        md: "80%"
      },
      boxShadow: 2,
    }}>
      {/* Categories */}
      <Typography
        variant="h6"
        sx={{ mb: 1, fontWeight: 500, textTransform: "uppercase" }}
      >
        Categories
      </Typography>
      <List dense sx={{ mb: 3 }}>
        {categories.map((cat) => (
          <ListItem
            key={cat}
            button
            sx={{
              pl: 0,
              cursor: "pointer",
              color: "secondary.main",
              "& :hover": {
                fontWeight: 500
              },
            }}
            onClick={() => {
              categoryFiltered(cat);
            }}
          >
            <ListItemText
              primary={`• ${cat}`}
              primaryTypographyProps={{ fontSize: "14px" }}
            />
          </ListItem>
        ))}
      </List>

      <Divider sx={{ mb: 3, height: 3, backgroundColor: "black" }} />

      {/* Recent Posts */}
      <Typography
        variant="h6"
        sx={{ mb: 1, fontWeight: 500, textTransform: "uppercase" }}
      >
        Recent Posts
      </Typography>
      <List dense>
        {recentPosts?.map((post) => (
          <ListItem
            key={post.id}
            component={NavLink}
            to={`/blog-details/${titleToUrl(post.title)}`}
            sx={{
              textDecoration: "none",
              color: "textPrimary.main",
              "& :hover": {
                color: "secondary.main",
                fontWeight: 400,
              },
            }}
          >
            <ListItemText
              primary={`• ${post.title}`}
              primaryTypographyProps={{ fontSize: "14px" }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default Sidebar;
